export const triggerPressOnDomLoaded = () => [...document.querySelectorAll('.js-press-on-dom-loaded')].forEach((e) => (e === null || e === void 0 ? void 0 : e.click) && e.click());
